import React from 'react';
import styled from 'styled-components';

const FooterStyle = styled.footer`
  .footer-wrapper {
    background-color: #54565A;
  }

  .footer {
    display: flex;
    padding: 1.5rem 0;
    margin: 0 15%;
  }

  .footer-text {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: white;
  }
`;

//     <footer id="footer">
//       <div className="container">
//         © {new Date().getFullYear()}, Built with{` `}<a href="https://www.gatsbyjs.com">Gatsby</a>
//       </div>
//     </footer>

export default function Footer(){
  return (
    <FooterStyle id="footer">
      <div className="footer-wrapper">
        <div className="footer">
          <div className="footer-text">Copyright 2022 Awesome Company. All Rights Reserved.</div>
        </div>
      </div>
    </FooterStyle>
  );
}
